import { render, staticRenderFns } from "./CoLivingTabs.vue?vue&type=template&id=13587b3e&"
import script from "./CoLivingTabs.vue?vue&type=script&lang=js&"
export * from "./CoLivingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13587b3e')) {
      api.createRecord('13587b3e', component.options)
    } else {
      api.reload('13587b3e', component.options)
    }
    module.hot.accept("./CoLivingTabs.vue?vue&type=template&id=13587b3e&", function () {
      api.rerender('13587b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/CoLivingTabs.vue"
export default component.exports